var reviewTypeMap = {
  VENDOR: 'Seller',
  BUYER: 'Seller'
};
var millisecondsToWeeks = msec => {
  var weeks = msec / 1000 / 60 / 60 / 24 / 365 * 52;
  return weeks > 1 ? Math.round(weeks) : 1;
};
var subtitlePrefix = (type, reviewSuburb) => {
  var reviewType = reviewTypeMap[type] ? "".concat(reviewTypeMap[type], " recommendation") : '';
  var suburb = reviewSuburb ? ", ".concat(reviewSuburb) : '';
  return "".concat(reviewType).concat(suburb);
};
var subtitleSuffix = reviewDate => {
  var numWeeks = 1;
  if (reviewDate) {
    numWeeks = millisecondsToWeeks(new Date() - new Date(reviewDate));
  }
  return "".concat(numWeeks, " week").concat(numWeeks > 1 ? 's' : '', " ago");
};
var truncateTextToNearestSpace = (text, maxlength) => {
  var length = maxlength;
  if (text && maxlength >= 1) {
    // text exists and is longer than 1 char
    if (text.length > maxlength) {
      // text is longer than desired truncation
      if (text.charAt(maxlength) !== ' ') {
        // next character of truncation is not space
        length = text.substr(0, maxlength).lastIndexOf(' ');
      }
    }
    return text.substr(0, length);
  }
  return '';
};
export { reviewTypeMap, subtitlePrefix, subtitleSuffix, truncateTextToNearestSpace };